import { 
  File, 
  FileText, 
  Image, 
  Video, 
  Music, 
  FileCode, 
  FileSpreadsheet 
} from 'lucide-react';

// Get appropriate icon for file type
export const getFileIcon = (mimeType) => {
  // Images - blue
  if (mimeType?.startsWith('image/')) return <Image className="w-5 h-5 text-blue-500" />;
  
  // PDFs - red
  if (mimeType?.includes('pdf')) return <FileText className="w-5 h-5 text-red-500" />;
  
  // Videos - purple
  if (mimeType?.startsWith('video/')) return <Video className="w-5 h-5 text-purple-500" />;
  
  // Audio - green
  if (mimeType?.startsWith('audio/')) return <Music className="w-5 h-5 text-green-500" />;
  
  // Text/Code files - orange
  if (mimeType?.startsWith('text/')) return <FileCode className="w-5 h-5 text-orange-500" />;
  
  // Spreadsheets - green
  if (mimeType?.includes('spreadsheet') || mimeType?.includes('excel') || mimeType?.includes('csv')) {
    return <FileSpreadsheet className="w-5 h-5 text-emerald-600" />;
  }
  
  // Word documents - blue
  if (mimeType?.includes('word') || mimeType?.includes('document')) {
    return <FileText className="w-5 h-5 text-blue-600" />;
  }
  
  // Default - gray
  return <File className="w-5 h-5 text-gray-500" />;
};

// Download file from URL
export const downloadFromUrl = (url, filename) => {
  if (!url) return;
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};

// Check if file is previewable
export const isPreviewableFile = (mimeType) => {
  return mimeType?.startsWith('image/') ||
         mimeType?.startsWith('video/') ||
         mimeType?.startsWith('audio/') ||
         mimeType === 'application/pdf' ||
         mimeType?.startsWith('text/');
};
